/* eslint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config file > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/



import {QLayout,QHeader,QDrawer,QPageContainer,QPage,QToolbar,QToolbarTitle,QBtn,QIcon,QList,QItem,QItemSection,QItemLabel,QCard,QCardSection,QCardActions,QInput,QSelect,QTable,QTh,QTr,QTd,QDialog,QImg,QAvatar,QScrollArea,QSpinner,QBadge,QSpace,QOptionGroup,QBtnGroup,QSlider,QToggle,Dialog,Notify,Dark,BottomSheet,Loading} from 'quasar'



export default { config: {"brand":{"primary":"#9c0000","secondary":"#6a0000","accent":"#c00000","dark":"#1d1d1d","positive":"#21BA45","negative":"#C10015","info":"#31CCEC","warning":"#F2C037"},"touchPlugin":{"defaultPreventedEvents":[],"passiveCapture":true}},components: {QLayout,QHeader,QDrawer,QPageContainer,QPage,QToolbar,QToolbarTitle,QBtn,QIcon,QList,QItem,QItemSection,QItemLabel,QCard,QCardSection,QCardActions,QInput,QSelect,QTable,QTh,QTr,QTd,QDialog,QImg,QAvatar,QScrollArea,QSpinner,QBadge,QSpace,QOptionGroup,QBtnGroup,QSlider,QToggle},plugins: {Dialog,Notify,Dark,BottomSheet,Loading} }

